import { useContext } from 'react'
import { SubscriptionProvider, useSubscriptionContext, SubscriptionInfo } from '@/components/subscription-provider'

// Re-export types
export type { SubscriptionInfo }

/**
 * Hook to access subscription data.
 * Tries to use the global SubscriptionContext first.
 * If used outside the provider, it throws an error (or we could implement fallback, but context is preferred).
 */
export function useSubscription() {
  try {
    return useSubscriptionContext()
  } catch (e) {
    // Fallback logic if needed, or re-throw if we want to enforce Provider usage
    // For now, let's re-throw to ensure we wrap the app correctly
    // Actually, for safety during migration, let's return a dummy loading state or implement the local logic again?
    // Better: Let's just assume it's wrapped. If not, the error will be clear.

    // However, to avoid breaking pages that might not be wrapped yet (like auth pages if they used it),
    // we could return a safe default. But auth pages don't use subscription usually.
    throw e
  }
}

